import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { LoadingSpinner } from "../../../components/layout/LoadingSpinner";
import ErrorHandler from "../../../components/core/ErrorHandler";
import { Row, Col, Form, Button } from "react-bootstrap";
import "./ContactAdmin.css";
import SharedContactAdminGrid from "./SharedContactAdminGrid";
import {
  rpidHeaderConstants,
  groupHeaderConstants,
} from "./ContactAdminConstants";
import { GridColumn } from "@progress/kendo-react-grid";
import { UserContext } from "shared/context/UserContext";
import { DefaultColumnWidth } from "../../../components/grid/Kendo/KendoGridAndColumnConstants";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";

export default function ContactAdmin(props) {
  const { passedProps } = props;
  const userEmail = passedProps.user.email;
  const [superAdmin, setSuperAdmin] = useState(null);
  const [groupOptions, setGroupOptions] = useState([]);
  const [rpidOptions, setRpidOptions] = useState([]);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(props.columns ? props.columns : []);
  const [featureTiers, setFeatureTiers] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [isGroupChecked, setIsGroupChecked] = useState(false);
  const [isRpidChecked, setIsRpidChecked] = useState(false);
  const DATA_ITEM_KEY = "contactID";

  const [error, setError] = useState({});
  const navigate = useNavigate();

  const [currentGroup, setCurrentGroup] = useState(null);
  const [currentRpid, setCurrentRpid] = useState(null);

  const [parentOrGroupData, setParentOrGroupData] = useState();
  const [selectedParentOrGroup, setSelectedParentOrGroup] = useState({});

  const [headerConstantsToUse, setHeaderConstantsToUse] = useState(null);

  // if( currentRpid ) {
  //   headerConstantsToUse = rpidHeaderConstants;
  // }
  // else{
  //   headerConstantsToUse = groupHeaderConstants;
  // }

  const CustomActionCell = (props) => (
    <CustomCellCheckBox {...props} color={"#015CAB"} />
  );

  const EmailCell = (props) => {
    return (
      <td
        style={{
          whiteSpace: "normal",
          wordWrap: "break-word",
          wordBreak: "break-word",
        }}
      >
        {props.dataItem[props.field]}
      </td>
    );
  };

  const user = useContext(UserContext);

  useEffect(() => {
    getIsSuperAdmin();
  }, []);

  useEffect(() => {
    GetUserParentCompanies();
    GetUserGroups();
  }, [superAdmin]);

  useEffect(() => {
    if (superAdmin != null) {
      if (
        superAdmin.contactType === "PCT" ||
        superAdmin.contactType === "MCT"
      ) {
        setParentOrGroupData(rpidOptions);
      }
      if (superAdmin.contactType === "GCT") {
        setParentOrGroupData(groupOptions);
      }
    }
  }, [groupOptions, rpidOptions]);

  async function GetUserGroups() {
    const accessToken = await passedProps.auth.getAccessToken();
    let userGroups = await axios.get("api/UserProgram/GetUserGroups", {
      params: {
        email: userEmail,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    setGroupOptions(formatDictionaryToArray(userGroups.data));
  }

  async function GetAdminContacts() {
    if (
      !selectedParentOrGroup.selectedItem ||
      !selectedParentOrGroup.selectedItem.value
    ) {
      return;
    }
    var id = selectedParentOrGroup.selectedItem.value;
    if (id == "") {
      return;
    }

    setIsLoading(true);
    const accessToken = await passedProps.auth.getAccessToken();

    let parameters = {
      id: selectedParentOrGroup.selectedItem.value,
      type: isRpidChecked ? "RPID" : "Group",
    };

    let adminContacts = await axios.get("api/UserProgram/GetAdminContacts", {
      params: parameters,
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    setData(adminContacts.data);

    let headerConstants;
    if (isRpidChecked) {
      setCurrentGroup(null);
      setCurrentRpid(selectedParentOrGroup.selectedItem.value);
      headerConstants = rpidHeaderConstants;
      setHeaderConstantsToUse(rpidHeaderConstants);
    } else {
      setCurrentGroup(selectedParentOrGroup.selectedItem.value);
      setCurrentRpid(null);
      headerConstants = groupHeaderConstants;
      setHeaderConstantsToUse(groupHeaderConstants);
    }

    setGridData(adminContacts.data, headerConstants);

    GetRmeFeatureTiers();
    setIsLoading(false);
  }

  async function GetRmeFeatureTiers() {
    var id = selectedParentOrGroup.selectedItem.value;
    if (id == "") return;
    const accessToken = await passedProps.auth.getAccessToken();
    let featureTiers = await axios.get(
      "api/UserProgram/GetRmeTiersForGroupOrParentCompany",
      {
        params: {
          id: selectedParentOrGroup.selectedItem.value,
          type: isRpidChecked ? "ParentCompany" : "Group",
        },
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );
    setFeatureTiers(featureTiers.data);
  }

  async function GetUserParentCompanies() {
    if (superAdmin == null) return;

    const accessToken = await passedProps.auth.getAccessToken();
    let userGroups = await axios.get("api/UserProgram/GetUserParentCompanies", {
      params: {
        email: userEmail,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    setRpidOptions(formatDictionaryToArray(userGroups.data));
  }

  function formatDictionaryToArray(data) {
    let outputArray = Object.keys(data).map((key) => {
      return {
        label: data[key],
        value: key,
      };
    });

    outputArray.sort((a, b) => a.label.localeCompare(b.label));

    return outputArray;
  }
  async function getIsSuperAdmin() {
    const accessToken = await passedProps.auth.getAccessToken();
    let parameters = {
      email: userEmail,
    };
    let userResponse = await axios.get(`api/UserProgram/GetSuperUser`, {
      params: parameters,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    setSuperAdmin(userResponse.data);
    if (!userResponse.data.isSuperUser) {
      navigate("/");
    }

    if (userResponse.data.contactType == "GCT") {
      setIsGroupChecked(true);
    }

    if (
      userResponse.data.contactType == "PCT" ||
      userResponse.data.contactType == "MCT"
    ) {
      setIsRpidChecked(true);
    }
  }

  const RenderDropdownSelection = () => {
    //NOTE: Each option is just a {label: "string", value: "string"} object
    const filterData = (filter) => {
      const filteredData = isGroupChecked
        ? groupOptions.slice()
        : rpidOptions.slice();
      return filterBy(filteredData, filter);
    };

    const filterChange = (event) => {
      setParentOrGroupData(filterData(event.filter));
    };

    const handleChange = (event) => {
      setSelectedParentOrGroup({
        selectedItem: event.target.value,
      });
    };

    return (
      <DropDownList
        data={parentOrGroupData}
        textField="label"
        value={
          selectedParentOrGroup && selectedParentOrGroup.selectedItem
            ? selectedParentOrGroup.selectedItem
            : null
        }
        onChange={handleChange}
        filterable={true}
        onFilterChange={filterChange}
        style={{
          width: "300px",
        }}
      />
    );
  };

  const RenderRadioButtonForChoosingParentCompanyOrGroupOptions = () => {
    if (superAdmin == null) return;
    if (superAdmin.contactType === "GCT") {
      return (
        <Form.Check
          onChange={(e) => onTypeChange(e)}
          custom="true"
          type="radio"
          id="ReportTypeDR-1"
          name="Type"
          label="Group"
          value="group"
          inline
          checked={true}
        />
      );
    } else if (
      superAdmin.contactType === "PCT" ||
      superAdmin.contactType === "MCT"
    ) {
      return (
        <Form.Check
          onChange={(e) => onTypeChange(e)}
          custom="true"
          type="radio"
          id="ReportTypeDR-2"
          name="Type"
          label="RPID"
          value="rpid"
          inline
          checked={true}
        />
      );
    } else {
      return (
        <React.Fragment>
          <Form.Check
            onChange={(e) => onTypeChange(e)}
            custom="true"
            type="radio"
            id="ReportTypeDR-1"
            name="Type"
            label="Group"
            value="group"
            inline
          />
          <Form.Check
            onChange={(e) => onTypeChange(e)}
            custom="true"
            type="radio"
            id="ReportTypeDR-2"
            name="Type"
            label="RPID"
            value="rpid"
            inline
          />
        </React.Fragment>
      );
    }
  };

  function onTypeChange(e) {
    setSelectedParentOrGroup({});

    if (e.target.value === "rpid") {
      setParentOrGroupData(rpidOptions);

      setIsRpidChecked(e.target.checked);
      setIsGroupChecked(!e.target.checked);
    }
    if (e.target.value === "group") {
      setParentOrGroupData(groupOptions);

      setIsGroupChecked(e.target.checked);
      setIsRpidChecked(!e.target.checked);
    }
  }

  function setGridData(data, headerConstants = headerConstantsToUse) {
    let rows = data;
    const columns = [];

    if (rows.length > 0 && headerConstants && headerConstants.headerProps) {
      const headerProps = headerConstants.headerProps;

      Object.keys(rows[0]).map((key) => {
        if (headerProps[key]) {
          return columns.push({
            accessor: key,
            title: headerProps[key].title,
            type: headerProps[key].type,
            hidden: headerProps[key].hidden,
          });
        }
      });

      setError({});
      setColumns(columns);
    } else {
      setError({ status: 201, Message: "No data found for given parameters" });
    }
  }

  const UpdateDataSource = (contactID, fieldName, check) => {
    // Self property update or Self object update
    let processedData = data.map((value) => {
      let newObject = value;
      if (value.contactID === contactID) {
        if (fieldName === "ltcMetricEssentials") {
          newObject.ltcMetricEssentials = check;
        }
        if (fieldName === "rec2") {
          newObject.rec2 = check;
        }
        if (fieldName === "ltcMetricElite") {
          newObject.ltcMetricElite = check;
        }
        if (fieldName === "retailMetricEssentials") {
          newObject.retailMetricEssentials = check;
        }
        if (fieldName === "retailMetricElite") {
          newObject.retailMetricElite = check;
        }
      }
      return newObject;
    });
    setGridData(processedData, headerConstantsToUse);
  };

  const CustomCellCheckBox = (props) => {
    let columnName = props.field;
    switch (columnName) {
      case "rec2":
        return (
          <td>
            <input
              type="checkbox"
              className="action-cell"
              data-testid={"action-rec-" + props.id}
              onChange={(e) => {
                UpdateDataSource(
                  props.dataItem.contactID,
                  "rec2",
                  e.currentTarget.checked
                );
              }}
              checked={props.dataItem.rec2}
              disabled={!featureTiers.rec2}
              title={
                featureTiers.rec2
                  ? ""
                  : "There are no pharmacies with a Rec 2.0 or Data Maintenance subscription."
              }
            ></input>
          </td>
        );
      case "ltcMetricEssentials":
        return (
          <td>
            <input
              type="checkbox"
              className="action-cell"
              data-testid={"action-metric" + props.id}
              onChange={(e) => {
                UpdateDataSource(
                  props.dataItem.contactID,
                  "ltcMetricEssentials",
                  e.currentTarget.checked
                );
              }}
              checked={props.dataItem.ltcMetricEssentials}
              disabled={!featureTiers.ltcMetricEssentials}
              title={
                featureTiers.ltcMetricEssentials
                  ? ""
                  : "There are no pharmacies with a LTC Metric Essentials subscription."
              }
            ></input>
          </td>
        );
      case "ltcMetricElite":
        return (
          <td>
            <input
              type="checkbox"
              className="action-cell"
              data-testid={"action-metricPremium" + props.id}
              onChange={(e) => {
                UpdateDataSource(
                  props.dataItem.contactID,
                  "ltcMetricElite",
                  e.currentTarget.checked
                );
              }}
              checked={props.dataItem.ltcMetricElite}
              disabled={!featureTiers.ltcMetricElite}
              title={
                featureTiers.ltcMetricElite
                  ? ""
                  : "There are no pharmacies with a LTC Metric Elite subscription."
              }
            ></input>
          </td>
        );
      case "retailMetricEssentials":
        return (
          <td>
            <input
              type="checkbox"
              className="action-cell"
              data-testid={"action-retail-metric-essentials-" + props.id}
              onChange={(e) => {
                UpdateDataSource(
                  props.dataItem.contactID,
                  "retailMetricEssentials",
                  e.currentTarget.checked
                );
              }}
              checked={props.dataItem.retailMetricEssentials}
              disabled={!featureTiers.retailMetricEssentials}
              title={
                featureTiers.retailMetricEssentials
                  ? ""
                  : "There are no pharmacies with a Retail Metric Essentials subscription."
              }
            ></input>
          </td>
        );
      case "retailMetricElite":
        return (
          <td>
            <input
              type="checkbox"
              className="action-cell"
              data-testid={"action-retail-metric-elite-" + props.id}
              onChange={(e) => {
                UpdateDataSource(
                  props.dataItem.contactID,
                  "retailMetricElite",
                  e.currentTarget.checked
                );
              }}
              checked={props.dataItem.retailMetricElite}
              disabled={!featureTiers.retailMetricElite}
              title={
                featureTiers.retailMetricElite
                  ? ""
                  : "There are no pharmacies with a Retail Metric Elite subscription."
              }
            ></input>
          </td>
        );
      default:
        return (
          <td
            {...props.tdProps}
            colSpan={1}
            style={{
              color: props.color,
            }}
          ></td>
        );
    }
  };

  function CreateGridColumn(column) {
    let columnWidth = DefaultColumnWidth();

    // Set specific widths for different column types
    if (column.accessor === "contactType") {
      columnWidth = 110; // Slightly wider to accommodate "Contact Type" header
    } else if (
      column.accessor === "firstName" ||
      column.accessor === "lastName"
    ) {
      columnWidth = 140; // Wide enough for headers and content
    } else if (column.accessor === "contactEmail") {
      columnWidth = 280; // Wider for email to accommodate wrapping
    }

    let filterType = "text";
    if (column.type === "money" || column.type === "number") {
      filterType = "numeric";
    }

    if (column.hidden) {
      return;
    }
    if (column.type === "custom") {
      // Calculate appropriate width for checkbox columns based on title length
      let checkboxColumnWidth = 150; // Default for longer titles

      if (column.accessor === "rec2") {
        checkboxColumnWidth = 80; // "Rec 2.0" is shorter
      } else if (
        column.accessor === "ltcMetricEssentials" ||
        column.accessor === "retailMetricEssentials"
      ) {
        checkboxColumnWidth = 160; // "LTC/Retail Metric Essentials" needs more space
      } else if (
        column.accessor === "ltcMetricElite" ||
        column.accessor === "retailMetricElite"
      ) {
        checkboxColumnWidth = 130; // "LTC/Retail Metric Elite" is medium length
      }

      return (
        <GridColumn
          key={column.accessor}
          field={column.accessor}
          title={column.title}
          width={checkboxColumnWidth}
          filterable={false}
          cells={{
            data: CustomActionCell,
          }}
        />
      );
    } else {
      return (
        <GridColumn
          key={column.accessor + "Column"}
          filter={filterType}
          field={column.accessor}
          title={column.title}
          filterable={true}
          width={columnWidth}
          cells={{
            data: column.accessor === "contactEmail" ? EmailCell : undefined,
          }}
        />
      );
    }
  }

  const Spacer = (prop) => {
    return <div style={{ height: prop.height }}></div>;
  };

  async function GenerateOktaAccountsForListOfContacts(contacts) {
    const accessToken = await passedProps.auth.getAccessToken();

    try {
      //NOTE: If a feature is disabled in the featurTiers object, then also all permissions of that feature for the contact is disabled as well
      if (!featureTiers.rec2) {
        contacts.forEach((contact) => {
          contact.rec2 = false;
        });
      }
      if (!featureTiers.ltcMetricEssentials) {
        contacts.forEach((contact) => {
          contact.ltcMetricEssentials = false;
        });
      }
      if (!featureTiers.ltcMetricElite) {
        contacts.forEach((contact) => {
          contact.ltcMetricElite = false;
        });
      }
      if (!featureTiers.retailMetricEssentials) {
        contacts.forEach((contact) => {
          contact.retailMetricEssentials = false;
        });
      }
      if (!featureTiers.retailMetricElite) {
        contacts.forEach((contact) => {
          contact.retailMetricElite = false;
        });
      }

      let parentCompanyOrGroupType = "N/A";
      let selectedParentCompanyOrGroupId = "";
      let parentCompanyOrGroupName = "";

      if (currentGroup !== null) {
        parentCompanyOrGroupType = "Group";
        let entity = groupOptions.filter((p) => p.value == currentGroup)[0];
        selectedParentCompanyOrGroupId = currentGroup;
        parentCompanyOrGroupName = entity.label;
      } else if (currentRpid !== null) {
        parentCompanyOrGroupType = "ParentCompany";
        let entity = rpidOptions.filter((p) => p.value == currentRpid)[0];
        selectedParentCompanyOrGroupId = currentRpid;
        parentCompanyOrGroupName = entity.label;

        //NOTE: If permissions are being applied for parent company contacts, force all Elite features to false
        contacts.forEach((contact) => {
          contact.ltcMetricElite = false;
          contact.retailMetricElite = false;
        });
      }

      await axios
        .post(
          "api/UserProgram/GenerateOktaAccountsAndGrantRmeAccessForContacts",
          {
            contacts: contacts,
            superUserEmail: userEmail,
            ParentCompanyOrGroupName: parentCompanyOrGroupName,
            ParentCompanyOrGroupId: selectedParentCompanyOrGroupId,
            ParentCompanyOrGroupType: parentCompanyOrGroupType,
          },
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        )
        .then((response) => {
          setError({ status: 200, Message: "Grant access success!" });
        })
        .catch((err) => {
          console.log(err);
          setError({
            status: 201,
            Message:
              err && err.response && err.response.data
                ? err.response.data
                : "Error occurred while granting access to contacts. Please notify the Net-Rx team.",
          });

          // setError(err);
        });
    } catch (e) {
      console.log(e);
      setError({
        status: 201,
        Message:
          "Unable to grant access to these contacts, please notify Net-Rx team and try again later.",
      });
    }

    setIsLoading(false);
  }
  function checkForPctUsers(contacts) {
    var pctUsersWithARecFeature = contacts.filter(
      (x) =>
        x.contactType === "PCT" &&
        (x.ltcMetricEssentials ||
          x.ltcMetricElite ||
          x.rec2 ||
          x.retailMetricEssentials ||
          x.retailMetricElite)
    );

    if (pctUsersWithARecFeature.length > 0) {
      return window.confirm(
        "The selected PCT users will receive permissions for all pharmacies within this parent company. Would you like to proceed?"
      );
    } else {
      return true;
    }
  }
  function checkForUsersWithBothEliteAndEssential(contacts) {
    var usersWithMultipleMetricFeatures = contacts.filter((x) => {
      const enabledFeatures = [
        x.ltcMetricEssentials,
        x.ltcMetricElite,
        x.retailMetricEssentials,
        x.retailMetricElite,
      ].filter(Boolean);
      return enabledFeatures.length > 1;
    });

    if (
      usersWithMultipleMetricFeatures &&
      usersWithMultipleMetricFeatures.length > 0
    ) {
      alert(
        "Contacts cannot have multiple tiers of Metric features at the same time. Please review your selections and try again."
      );
      return false;
    } else {
      return true;
    }
  }

  async function handleGrantAccess() {
    let continueWithContactGenerationBecausePctUsersAreOkay =
      checkForPctUsers(data);

    let continueWithContactGenerationBecauseNoUsersHaveBothEliteAndEssential =
      checkForUsersWithBothEliteAndEssential(data);

    if (
      continueWithContactGenerationBecausePctUsersAreOkay &&
      continueWithContactGenerationBecauseNoUsersHaveBothEliteAndEssential
    ) {
      // alert("Granting access to contacts. Please wait for the success message.");

      setIsLoading(true);
      await GenerateOktaAccountsForListOfContacts(data);
    }
  }

  return (
    <div className="feature">
      <LoadingSpinner isDataLoading={isLoading} controlsName={"ContactAdmin"} />
      <ErrorHandler
        error={error}
        onClose={() => {
          setError({});
        }}
      />
      <Row className="justify-content-start">
        <Col md="auto">
          {RenderRadioButtonForChoosingParentCompanyOrGroupOptions()}
        </Col>
        <Col md="auto">{RenderDropdownSelection()}</Col>
        <Col md="auto">
          <Button
            className="show-result-button"
            size="sm"
            type="button"
            onClick={() => GetAdminContacts()}
          >
            Show Results
          </Button>
        </Col>
      </Row>
      <Spacer height="1rem" />
      <Row className="tight-grid multi-line-filter">
        <div className="justify-content-md-left">
          <SharedContactAdminGrid data={data} DATA_ITEM_KEY={DATA_ITEM_KEY}>
            {columns.length > 0
              ? columns.map((singleColumn) => CreateGridColumn(singleColumn))
              : null}
          </SharedContactAdminGrid>
        </div>
      </Row>
      <Spacer height="1rem" />
      <Row className="justify-content-md-left">
        <Col md="auto">
          <Button
            className="show-result-button"
            size="sm"
            type="button"
            onClick={async () => await handleGrantAccess()}
          >
            Grant Access
          </Button>
        </Col>
      </Row>
    </div>
  );
}